// extracted by mini-css-extract-plugin
export default {"tableWrap":"Parsing_tableWrap__pldiY","status":"Parsing_status__6-+nV","runStatus":"Parsing_runStatus__5QbKt","providerTable":"Parsing_providerTable__V-xky"};